import { render, staticRenderFns } from "./view-client-applications.vue?vue&type=template&id=248ac892"
import script from "./view-client-applications.vue?vue&type=script&lang=js"
export * from "./view-client-applications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports